import React from 'react';

export default class PhotoElement extends React.PureComponent {
  deletePhoto = event => {
    event.stopPropagation();
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { actions } = this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    actions.deletePhoto(event.currentTarget.getAttribute('data-id'));
  };

  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { value, myKey } = this.props;
    return (
      <div key={myKey} className='ph-elem'>
        <div className='ph-area'>
          <i
            className='fas fa-times ph-rem-button'
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/prop-types
            data-id={value.id}
            onClick={this.deletePhoto}
          />
        </div>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        <img alt='guides_photo' className='grid_photo' src={value.data} />
      </div>
    );
  }
}
